import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function notEmptyArrayValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const isValid = Array.isArray(control.value) && control.value.length > 0;
    return isValid ? null : { notEmptyArray: true };
  };
}